import Image from 'next/image';
import { AppNextLink } from '@/features/app-next-link';
import { getCdnUrl } from '@/utils/url';
function Logo() {
  return <AppNextLink prefetch={false} href='/' className='lg:flex-initial' data-sentry-element="AppNextLink" data-sentry-component="Logo" data-sentry-source-file="logo.tsx">
            <Image src={getCdnUrl('/_toad/images/brand/logo.svg?v=1.1')} alt='Khanoumi Logo' width={96} height={48} priority unoptimized className='max-h-8 w-20 lg:h-12 lg:max-h-none lg:w-24' data-sentry-element="Image" data-sentry-source-file="logo.tsx" />
        </AppNextLink>;
}
export default Logo;